<template>
  <div class="text-center py-8 px-4">
    <slot name="title" />
    <div
      id="checkout-error"
      class="bg-red-100 border border-red-400 px-4 py-3 mt-4 rounded text-center"
      :class="missingFields.length > 0 ? 'block':'hidden'"
      role="alert"
    >
      <h6 class="font-bold text-red-700">
        {{ missingFields }}
      </h6>
      <p class="text-red-700">
        If you can't resolve the issue, try <nuxt-link
          to="/support"
          target="_blank"
          class="text-red-700"
        >
          clicking here
        </nuxt-link>
        or emailing
        customerservice@summit-education.com
      </p>
    </div>
    <form
      class="pt-4 w-full max-w-lg"
      @submit.prevent="handleSubmit"
    >
      <div class="flex flex-wrap -mx-3 mb-6">
        <div class="w-full px-3">
          <input
            v-model="email"
            required
            class="placeholder-black appearance-none block w-full text-black font-bold border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            type="email"
            placeholder="Email"
          />
        </div>
      </div>
      <div class="flex flex-wrap -mx-3 mb-6">
        <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
          <input
            v-model="name"
            required
            class="placeholder-black appearance-none block w-full text-black font-bold border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            type="text"
            name="name"
            placeholder="First Name"
          />
        </div>
        <div class="w-full md:w-1/2 px-3">
          <input
            v-model="zipcode"
            required
            class="placeholder-black appearance-none block w-full text-black font-bold border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            name="zipcode"
            placeholder="Zip Code"
            pattern="\d*"
            title="Exactly 5 numeric digits"
            type="text"
            minlength="5"
            maxlength="5"
          />
        </div>
      </div>
      <div class="flex flex-wrap -mx-3 mb-2">
        <div class="w-full px-3 mb-6 md:mb-0">
          <profile-professions
            v-model="profession"
            required
            class="placeholder-black appearance-none block w-full text-black font-bold"
            variant="signup"
            key-name="id"
            label-key="id"
            value-key="id"
            name="profession"
          />
        </div>
      </div>
      <div class="flex flex-wrap">
        <div class="w-full py-5">
          <t-button
            variant="ctaPrimary"
            class="font-bold email-signup"
          >
            Sign Up
            <t-icon
              name="chevron-right"
              class="text-white text-md"
              style="cursor: pointer;"
            />
          </t-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import ProfileProfessions from '@/components/account/ProfileProfessions';
import { emailSignUp, } from '@/services/iterable';
import { gtmEmailSignUp, } from '@/services/gtmManager';

export default {
  components: { ProfileProfessions },
  props: {
    source: {
      type: String,
      required: false,
      default: 'main',
    },
  },
  setup() {
    const eventTrackerScript = document.createElement('script');
    eventTrackerScript.setAttribute(
      'type',
      'application/javascript'
    );
    eventTrackerScript.setAttribute(
      'src',
      'https://summit-cloudfront.s3.amazonaws.com/js/event-tracker.js'
    );
    document.head.appendChild(eventTrackerScript);
  },
  data() {
    return {
      email: '',
      name: '',
      zipcode: '',
      profession: {
        type: Object,
        default: undefined,
      },
      professionString: {
        type: String,
        default: '',
      },
      missingFields: {
        type: String,
        default: () => '',
      },
    };
  },
  mounted() {
    document.onreadystatechange = () => {
      if (document.readyState) {
        if (this.$route.query.src === 'optin_monster') {
          this.name = this.$route.query.name;
          this.email = this.$route.query.email;
          this.zipcode = this.$route.query.zipcode;
          this.professionString = this.$route.query.profession;
          this.$nextTick(() => {
            this.handleSubmit();
          });
        }
      }
    };
  },
  methods: {
    async handleSubmit() {
      this.missingFields = '';
      if (this.$route.query.src !== 'optin_monster') {
        if (this.profession === undefined || this.profession.id === undefined) {
          this.missingFields = 'You must choose a profession!';
          return;
        }
        else {
          this.professionString = this.profession.id;
        }
      }

      await EventTracker.emailSignup.track({
        email: this.email,
        zipcode: this.zipcode,
        first_name: this.name,
        profession: this.professionString,
        source: this.source,
        type: 'marketing',
      })
        .then(async(response) => {
          gtmEmailSignUp(this.email, this.professionString);
          console.log('profession', this.professionString);
          if (this.$route.query.custom_event) {
            await emailSignUp(this.$route.query.custom_event, this.$route.query.email, this.professionString).then((response) => {
              console.log('email signup finished');
              if (this.$route.query.src === 'optin_monster' && this.$route.query.redirect === 'true' && this.$route.query.thankyoupage) {
                window.location.replace(this.$route.query.thankyoupage);
              }
              else {
                this.$router.push('/courses/email-signup-thank-you');
              }
            });
          }
          else {
            await this.$router.push('/courses/email-signup-thank-you');
          }
          console.log(response);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
